import {useEffect, useRef} from 'react'

export function blockOverflownScroll() {
    document.body.style.overflow = 'hidden'

    const layoutWrapper = document.getElementsByClassName('layout-wrapper')[0]
    if (layoutWrapper) {
        // layoutWrapper.style.marginRight = ''
    }

    const layoutTopBar = document.getElementsByClassName('layout-topbar')[0]
    if (layoutTopBar) {
        layoutTopBar.style.width = '100%'
    }
}

export function unblockOverflownScroll() {
    document.body.style.overflow = 'auto'

    const layoutWrapper = document.getElementsByClassName('layout-wrapper')[0]
    if (layoutWrapper) {
        // layoutWrapper.style.marginRight = ''
    }

    const layoutTopBar = document.getElementsByClassName('layout-topbar')[0]
    if (layoutTopBar) {
        layoutTopBar.style.width = '100%'
    }
}

export function blockTableOverflownScroll() {
    document.body.style.overflow = 'hidden'
    const layoutWrapper = document.getElementsByClassName('layout-wrapper')[0]
    if (layoutWrapper) {
        // layoutWrapper.style.marginRight = '8px'
    }

    const layoutTopBar = document.getElementsByClassName('layout-topbar')[0]
    if (layoutTopBar) {
        // layoutTopBar.style.width = 'calc(100% - 8px)'
    }
}

export function unblockTableOverflownScroll() {
    document.body.style.overflow = 'auto'

    const layoutWrapper = document.getElementsByClassName('layout-wrapper')[0]
    if (layoutWrapper) {
        // layoutWrapper.style.marginRight = ''
    }

    const layoutTopBar = document.getElementsByClassName('layout-topbar')[0]
    if (layoutTopBar) {
        // layoutTopBar.style.width = '100%'
    }
}

export default function BlockScroll({active, children}) {
    const wrapperRef = useRef(null)

    useEffect(() => {
        if (!!wrapperRef && !!active) {
            blockTableOverflownScroll()

            function handleClickOutside(event) {
                if (
                    wrapperRef.current &&
                    !wrapperRef.current.contains(event.target)
                ) {
                    unblockTableOverflownScroll()
                } else {
                    blockTableOverflownScroll()
                }
            }

            document.addEventListener('mousedown', handleClickOutside)
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener('mousedown', handleClickOutside)
            }
        } else {
            unblockTableOverflownScroll()
        }
    }, [active, wrapperRef])

    return (
        <div
            id="aaa"
            className="grid sm:col-12 md:col-10 justify-content-end p-0"
            ref={wrapperRef}>
            {children}
        </div>
    )
}
